import AuthLayout from '../layout/AuthLayout';
import AccountManagement from '../pages/account/accountManagement';
import RoleManagement from '../pages/account/roleManagement';
import Info from '../pages/account/info';
import QuanLyKhoiVideo from '../pages/lichvietvideo/quanlykhoivideo';
import CreateBlockVideo from '../pages/lichvietvideo/quanlykhoivideo/components/createBlockVideo';
import UpdateBlockVideo from '../pages/lichvietvideo/quanlykhoivideo/components/updateBlockVideo';
import QuanLyTagVideo from '../pages/lichvietvideo/quanlytagvideo';
import CreateTagVideo from '../pages/lichvietvideo/quanlytagvideo/components/createTagVideo';
import UpdateTagVideo from '../pages/lichvietvideo/quanlytagvideo/components/updateTagVideo';
import QuanLyVideo from '../pages/lichvietvideo/quanlyvideo';
import CreateVideo from '../pages/lichvietvideo/quanlyvideo/components/createVideo';
import UpdateVideo from '../pages/lichvietvideo/quanlyvideo/components/updateVideo';
import QuanLyViTri from '../pages/lichvietvideo/quanlyvitri';
import CreatePositionVideo from '../pages/lichvietvideo/quanlyvitri/components/createPositionVideo';
import UpdatePositionVideo from '../pages/lichvietvideo/quanlyvitri/components/updatePositionVideo';
import ThongKeVideo from '../pages/lichvietvideo/thongkevideo';
import QuanLyBaiViet from '../pages/lichvietweb/quanlybaiviet';
import QuanLyDanhMuc from '../pages/lichvietweb/quanlydanhmuc';
import Reconciliation from '../pages/onlinestore/doisoat';
import QuanLyDoiTac from '../pages/onlinestore/quanlydoitac';
import CreatePartner from '../pages/onlinestore/quanlydoitac/components/createPartner';
import UpdatePartner from '../pages/onlinestore/quanlydoitac/components/updatePartner';
import QuanLyItemKhoi from '../pages/onlinestore/quanlyitemkhoi';
import CreateBlockItem from '../pages/onlinestore/quanlyitemkhoi/components/createBlockItem';
import UpdateBlockItem from '../pages/onlinestore/quanlyitemkhoi/components/updateBlockItem';
import QuanLyKhoi from '../pages/onlinestore/quanlykhoi';
import CreateBlock from '../pages/onlinestore/quanlykhoi/components/createBlock';
import UpdateBlock from '../pages/onlinestore/quanlykhoi/components/updateBlock';
import QuanLyMiniApps from '../pages/onlinestore/quanlyminiapps';
import CreateMiniApp from '../pages/onlinestore/quanlyminiapps/components/createMiniApp';
import UpdateMiniApp from '../pages/onlinestore/quanlyminiapps/components/updateMiniApp';
import QuanLyTag from '../pages/onlinestore/quanlytags';
import CreateTag from '../pages/onlinestore/quanlytags/components/createTag';
import UpdateTag from '../pages/onlinestore/quanlytags/components/updateTag';
import { Navigate } from 'react-router-dom';
import CheckRouter from './CheckRouter';
// CMS Premium Module
import QuanLyDichVu from '../pages/cms/quanlydichvu';
import QuanLyServiceLdp from '../pages/cms/quanlyserviceldp';
import QuanLyGoiPremium from '../pages/cms/quanlygoipremium';
import QuanLyDonHang from '../pages/cms/quanlydonhang';
import DetailDonHang from '../pages/cms/quanlydonhang/detailDonHang';
import QuanLyPremium from '../pages/cms/quanlypremium';
import QuanLyUserFeature from '../pages/cms/quanlyuserfeature';
import QuanLyUser from '../pages/cms/quanlyuser';
import UserDetail from '../pages/cms/quanlyuser/userDetail';
import QuanLyHistoryPremium from '../pages/cms/quanlyhistorypremium';
import QuanLyMbPushBDSD from '../pages/cms/quanlymbpushbdsd';
import QuanLyStoreNoti from '../pages/cms/quanlystorenoti';
import QuanLyTinhNang from '../pages/cms/quanlytinhnang';
// Object & Event Module
import QuanLyTheLoaiSuKien from '../pages/cms/quanlytheloaisukien';
import QuanLyDanhMucSuKien from '../pages/cms/quanlydanhmucsukien';
import QuanLySuKienHeThong from '../pages/cms/quanlysukienhethong';
import QuanLySuKienNguoiDung from '../pages/cms/quanlysukiennguoidung';
import QuanLyLoaiDoiTuong from '../pages/cms/quanlyloaidoituong';
import QuanLyDoiTuong from '../pages/cms/quanlydoituong';
// Quản trị nội dung
import QuanLyDanhMucNoiDung from '../pages/cms/quanlydanhmucnoidung';
import QuanLyBaiVietND from '../pages/cms/quanlybaiviet';
import QuanLyAlbums from '../pages/cms/quanlyalbums';
import QuanLyHinhAnh from '../pages/cms/quanlyhinhanh';
import QuanLyVideoND from '../pages/cms/quanlyvideond';
import QuanLyFile from '../pages/cms/quanlyfile';
import QuanLyDanhNgon from '../pages/cms/quanlydanhngon';
import QuanLyCungHoangDao from '../pages/cms/quanlycunghoangdao';
import QuanLyTuVi from '../pages/cms/quanlytuvi';
import QuanLyThiep from '../pages/cms/quanlythiep';
import QuanLyDanhSach from '../pages/cms/quanlydanhsach';
import SurveyManagement from '../pages/survey/SurveyManagement';
import FeatureRatingConfigManagement from '../pages/survey/FeatureRatingConfigManagement';
import FeedbackFeatureConfigManagement from '../pages/survey/FeedbackFeatureConfigManagement';
import FeedbackManagement from '../pages/survey/FeedbackManagement';

// Next Module
import QuanLyAppVersion from '../pages/cms/quanlyappversion';
import QuanLyVersionAPI from '../pages/cms/quanlyversionapi';
import QuanLyDanhGiaUngDung from '../pages/cms/quanlydanhgiaungdung';
import QuanLyDanhGiaDichVu from '../pages/cms/quanlydanhgiadichvu';
import QuanLyCauHinh from '../pages/cms/quanlycauhinh';
import QuanLyTienIch from '../pages/cms/quanlytienich';
import QuanLyChienDich from '../pages/cms/quanlychiendich';
import QuanLyMaGiamGia from '../pages/cms/quanlymagiamgia';
import QuanLyCauHinhSucKhoeTinhThan from '../pages/cms/quanlycauhinhsuckhoetinhthan';
import QuanLyKhoiDichVu from '../pages/cms/quanlykhoidichvu';
import QuanLyNoiDungTruyenThong from '../pages/cms/quanlynoidungtruyenthong';
import QuanLyThanhVienGiaDinh from '../pages/cms/quanlythanhviengiadinh';

// Định nghĩa cấu hình route phẳng để dễ quản lý
const APP_ROUTES = [
  { path: 'info', element: <Info /> },
  { path: 'survey/management', element: <SurveyManagement />, permKey: '/survey-management' },
  {
    path: 'survey/feature-rating-config',
    element: <FeatureRatingConfigManagement />,
    permKey: ['/feature-rating-config', '/survey-management'],
  },
  {
    path: 'survey/feedback-feature-config',
    element: <FeedbackFeatureConfigManagement />,
    permKey: '/feedback-feature-config',
  },
  { path: 'survey/feedbacks', element: <FeedbackManagement />, permKey: '/survey-feedbacks' },


  // Online Store
  { path: 'online-store/quan-ly-khoi', element: <QuanLyKhoi />, permKey: '/quan-ly-khoi' },
  { path: 'online-store/quan-ly-khoi/them-khoi', element: <CreateBlock />, permKey: '/quan-ly-khoi' },
  { path: 'online-store/quan-ly-khoi/:blockId/sua-khoi', element: <UpdateBlock />, permKey: '/quan-ly-khoi' },
  { path: 'online-store/quan-ly-item-khoi', element: <QuanLyItemKhoi />, permKey: '/quan-ly-item-khoi' },
  {
    path: 'online-store/quan-ly-item-khoi/them-item-khoi',
    element: <CreateBlockItem />,
    permKey: '/quan-ly-item-khoi',
  },
  {
    path: 'online-store/quan-ly-item-khoi/:blockItemId/sua-item-khoi',
    element: <UpdateBlockItem />,
    permKey: '/quan-ly-item-khoi',
  },
  { path: 'online-store/quan-ly-mini-apps', element: <QuanLyMiniApps />, permKey: '/quan-ly-mini-apps' },
  { path: 'online-store/quan-ly-mini-apps/them-mini-app', element: <CreateMiniApp />, permKey: '/quan-ly-mini-apps' },
  {
    path: 'online-store/quan-ly-mini-apps/:miniAppId/sua-mini-app',
    element: <UpdateMiniApp />,
    permKey: '/quan-ly-mini-apps',
  },
  { path: 'online-store/quan-ly-tags', element: <QuanLyTag />, permKey: '/quan-ly-tags' },
  { path: 'online-store/quan-ly-tags/them-tag', element: <CreateTag />, permKey: '/quan-ly-tags' },
  { path: 'online-store/quan-ly-tags/:tagId/sua-tag', element: <UpdateTag />, permKey: '/quan-ly-tags' },
  { path: 'online-store/quan-ly-doi-tac', element: <QuanLyDoiTac />, permKey: '/quan-ly-doi-tac' },
  { path: 'online-store/quan-ly-doi-tac/them-doi-tac', element: <CreatePartner />, permKey: '/quan-ly-doi-tac' },
  {
    path: 'online-store/quan-ly-doi-tac/:partnerId/sua-doi-tac',
    element: <UpdatePartner />,
    permKey: '/quan-ly-doi-tac',
  },
  { path: 'online-store/reconcile/:partnerId', element: <Reconciliation />, permKey: '/reconcile' },

  // LV Video
  { path: 'lv-video/quan-ly-video', element: <QuanLyVideo />, permKey: '/quan-ly-video' },
  { path: 'lv-video/quan-ly-video/them-video', element: <CreateVideo />, permKey: '/quan-ly-video' },
  { path: 'lv-video/quan-ly-video/:videoId/sua-video', element: <UpdateVideo />, permKey: '/quan-ly-video' },
  { path: 'lv-video/quan-ly-khoi-video', element: <QuanLyKhoiVideo />, permKey: '/quan-ly-khoi-video' },
  {
    path: 'lv-video/quan-ly-khoi-video/them-khoi-video',
    element: <CreateBlockVideo />,
    permKey: '/quan-ly-khoi-video',
  },
  {
    path: 'lv-video/quan-ly-khoi-video/:blockVideoId/sua-khoi-video',
    element: <UpdateBlockVideo />,
    permKey: '/quan-ly-khoi-video',
  },
  { path: 'lv-video/quan-ly-tag-video', element: <QuanLyTagVideo />, permKey: '/quan-ly-tag-video' },
  { path: 'lv-video/quan-ly-tag-video/them-tag-video', element: <CreateTagVideo />, permKey: '/quan-ly-tag-video' },
  {
    path: 'lv-video/quan-ly-tag-video/:tagVideoId/sua-tag-video',
    element: <UpdateTagVideo />,
    permKey: '/quan-ly-tag-video',
  },
  { path: 'lv-video/quan-ly-vi-tri', element: <QuanLyViTri />, permKey: '/quan-ly-vi-tri' },
  { path: 'lv-video/quan-ly-vi-tri/them-position', element: <CreatePositionVideo />, permKey: '/quan-ly-vi-tri' },
  {
    path: 'lv-video/quan-ly-vi-tri/:positionVideoId/sua-position',
    element: <UpdatePositionVideo />,
    permKey: '/quan-ly-vi-tri',
  },

  // Lịch Việt Web
  { path: 'lichviet-web/quan-ly-bai-viet', element: <QuanLyBaiViet />, permKey: '/quan-ly-bai-viet' },
  { path: 'lichviet-web/quan-ly-danh-muc', element: <QuanLyDanhMuc />, permKey: '/quan-ly-danh-muc' },

  // CMS Premium
  { path: 'cms/quan-ly-dich-vu', element: <QuanLyDichVu />, permKey: '/quan-ly-dich-vu' },
  { path: 'cms/quan-ly-service-ldp', element: <QuanLyServiceLdp />, permKey: '/quan-ly-service-ldp' },
  { path: 'cms/quan-ly-goi-premium', element: <QuanLyGoiPremium />, permKey: '/quan-ly-goi-premium' },
  { path: 'cms/quan-ly-don-hang', element: <QuanLyDonHang />, permKey: '/quan-ly-don-hang' },
  { path: 'cms/quan-ly-don-hang/:id', element: <DetailDonHang />, permKey: '/quan-ly-don-hang' },
  { path: 'cms/quan-ly-premium', element: <QuanLyPremium />, permKey: '/quan-ly-premium' },
  { path: 'cms/quan-ly-user-feature', element: <QuanLyUserFeature />, permKey: '/quan-ly-user-feature' },
  { path: 'cms/quan-ly-user', element: <QuanLyUser />, permKey: '/quan-ly-user' },
  { path: 'cms/quan-ly-user/:id', element: <UserDetail />, permKey: '/quan-ly-user' },
  { path: 'cms/quan-ly-thanh-vien-gia-dinh', element: <QuanLyThanhVienGiaDinh />, permKey: '/quan-ly-thanh-vien-gia-dinh' },
  { path: 'cms/quan-ly-tinh-nang', element: <QuanLyTinhNang />, permKey: '/quan-ly-tinh-nang' },
  { path: 'cms/quan-ly-history-premium', element: <QuanLyHistoryPremium />, permKey: '/quan-ly-history-premium' },
  { path: 'cms/mb-push-bdsd', element: <QuanLyMbPushBDSD />, permKey: '/mb-push-bdsd' },
  { path: 'cms/store-notifications', element: <QuanLyStoreNoti />, permKey: '/store-notifications' },

  // Object & Event
  { path: 'cms/quan-ly-the-loai-su-kien', element: <QuanLyTheLoaiSuKien />, permKey: '/quan-ly-the-loai-su-kien' },
  { path: 'cms/quan-ly-danh-muc-su-kien', element: <QuanLyDanhMucSuKien />, permKey: '/quan-ly-danh-muc-su-kien' },
  { path: 'cms/quan-ly-su-kien-he-thong', element: <QuanLySuKienHeThong />, permKey: '/quan-ly-su-kien-he-thong' },
  { path: 'cms/quan-ly-su-kien-nguoi-dung', element: <QuanLySuKienNguoiDung />, permKey: '/quan-ly-su-kien-nguoi-dung' },
  { path: 'cms/quan-ly-loai-doi-tuong', element: <QuanLyLoaiDoiTuong />, permKey: '/quan-ly-loai-doi-tuong' },
  { path: 'cms/quan-ly-doi-tuong', element: <QuanLyDoiTuong />, permKey: '/quan-ly-doi-tuong' },

  // Quản trị nội dung
  { path: 'cms/quan-ly-danh-muc-noi-dung', element: <QuanLyDanhMucNoiDung />, permKey: '/quan-ly-danh-muc-noi-dung' },
  { path: 'cms/quan-ly-bai-viet-nd', element: <QuanLyBaiVietND />, permKey: '/quan-ly-bai-viet-nd' },
  { path: 'cms/quan-ly-albums', element: <QuanLyAlbums />, permKey: '/quan-ly-albums' },
  { path: 'cms/quan-ly-hinh-anh', element: <QuanLyHinhAnh />, permKey: '/quan-ly-hinh-anh' },
  { path: 'cms/quan-ly-video-nd', element: <QuanLyVideoND />, permKey: '/quan-ly-video-nd' },
  { path: 'cms/quan-ly-file', element: <QuanLyFile />, permKey: '/quan-ly-file' },
  { path: 'cms/quan-ly-danh-ngon', element: <QuanLyDanhNgon />, permKey: '/quan-ly-danh-ngon' },
  { path: 'cms/quan-ly-cung-hoang-dao', element: <QuanLyCungHoangDao />, permKey: '/quan-ly-cung-hoang-dao' },
  { path: 'cms/quan-ly-tu-vi', element: <QuanLyTuVi />, permKey: '/quan-ly-tu-vi' },
  { path: 'cms/quan-ly-thiep', element: <QuanLyThiep />, permKey: '/quan-ly-thiep' },
  { path: 'cms/quan-ly-danh-sach', element: <QuanLyDanhSach />, permKey: '/quan-ly-danh-sach' },

  // Next Module
  { path: 'cms/next/quan-ly-app-version', element: <QuanLyAppVersion />, permKey: '/quan-ly-app-version' },
  { path: 'cms/next/quan-ly-version-api', element: <QuanLyVersionAPI />, permKey: '/quan-ly-version-api' },
  { path: 'cms/next/danh-gia-ung-dung', element: <QuanLyDanhGiaUngDung />, permKey: '/danh-gia-ung-dung' },
  { path: 'cms/next/danh-gia-dich-vu', element: <QuanLyDanhGiaDichVu />, permKey: '/danh-gia-dich-vu' },
  { path: 'cms/next/quan-ly-cau-hinh', element: <QuanLyCauHinh />, permKey: '/quan-ly-cau-hinh' },
  { path: 'cms/next/quan-ly-tien-ich', element: <QuanLyTienIch />, permKey: '/quan-ly-tien-ich' },
  { path: 'cms/next/quan-ly-chien-dich', element: <QuanLyChienDich />, permKey: '/quan-ly-chien-dich' },
  { path: 'cms/next/quan-ly-ma-giam-gia', element: <QuanLyMaGiamGia />, permKey: '/quan-ly-ma-giam-gia' },
  { path: 'cms/next/quan-ly-cau-hinh-sktt', element: <QuanLyCauHinhSucKhoeTinhThan />, permKey: '/quan-ly-cau-hinh-sktt' },
  { path: 'cms/next/quan-ly-khoi-dich-vu', element: <QuanLyKhoiDichVu />, permKey: '/quan-ly-khoi-dich-vu' },
  { path: 'cms/next/quan-ly-noi-dung-truyen-thong', element: <QuanLyNoiDungTruyenThong />, permKey: '/quan-ly-noi-dung-truyen-thong' },

  // Admin
  { path: 'admin/account-management', element: <AccountManagement />, permKey: '/account-management' },
  { path: 'admin/role-management', element: <RoleManagement />, permKey: '/role-management' },
];

const UserRoutes = [
  {
    path: '/',
    element: <AuthLayout />,
    children: [
      { index: true, element: <Navigate to="/info" replace /> },
      // Loop qua mảng config để tạo Route
      ...APP_ROUTES.map((route) => ({
        path: route.path,
        element: <CheckRouter permKey={route.permKey}>{route.element}</CheckRouter>,
      })),
    ],
  },
  { path: '*', element: <Navigate to="/info" replace /> },
];

const UserKbankRoutes = [
  {
    path: '*',
    element: <AuthLayout></AuthLayout>,
  },
  {
    path: 'lv-video',
    element: <AuthLayout></AuthLayout>,
    children: [
      {
        path: 'thong-ke-video',
        element: <ThongKeVideo />,
      },
    ],
  },
];

export { UserRoutes, UserKbankRoutes };
